

import http from '@/features/shared/http/client'
import { Shot } from '../store/useShotListStore'

export interface AIGenerationOptions {
    mode: 'auto' | 'custom'
    shotCount?: number
    mood?: string
    visualStyle?: string
    sceneDuration?: string
}

export async function generateShotListAI(sceneText: string, options?: AIGenerationOptions): Promise<Shot[]> {
    console.log("Generating shot list using Cloud Function for text length:", sceneText.length)
    if (options) console.log("With options:", options)
    try {
        console.log("Calling Cloud Function (REST) via Axios...");

        const response = await http.post<Shot[]>('/generateShotListAI', { sceneText, options });

        console.log("Cloud Function Response Received");

        return response.data;
    } catch (e: any) {
        console.error('Error generating shot list via Cloud Function:', e)
        // Log detailed error info if available
        if (e.message) console.error("Error message:", e.message)
        if (e.code) console.error("Error code:", e.code)
        if (e.details) console.error("Error details:", e.details)
        throw e
    }
}
